import styled, { css } from 'styled-components';
import { CircularProgress } from '@mui/material';

import Button from '../../../../../components/Button';
import UserProfileCard from '../../../../components/UserProfileCard';
import colors from '../../../../../styles/colors';

const BUTTON_CONTAINER_WIDTH = 220;

// Secondary action: a white pill with an ink ring, so the only filled button in the
// row is the primary one. Both buttons used to share a mint fill, which made Claim and
// Mark as Read compete for the same emphasis.
const buttonStyles = css`
  margin: 10px 0px;
  background-color: ${colors.base.alpha};
  border-radius: 36px;
  color: ${colors.base.secondary2};
  font-size: 14px;
  padding: 8px 16px;
  font-weight: 400;
  text-transform: none;
  border: 1px solid ${colors.base.beta};
  &:hover {
    background-color: ${colors.base.gamma};
    border: 1px solid ${colors.base.beta};
    cursor: pointer;
  }
`;

const MarkAsReadButton = styled(Button)`
  ${buttonStyles};
`;

const RestoreButton = MarkAsReadButton;

// Primary action: solid lime, no contrasting ring.
const ClaimButton = styled(Button)`
  ${buttonStyles};
  background-color: ${colors.base.primary};
  border: 1px solid ${colors.base.primary};
  &:hover {
    background-color: ${colors.shades.primary4};
    border: 1px solid ${colors.shades.primary4};
  }
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: right;
  white-space: nowrap;
  column-gap: 10px;
  width: ${BUTTON_CONTAINER_WIDTH}px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  column-gap: 8px;
  justify-content: space-between;
`;

const LeftSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  flex: 1;
  width: calc(100% - ${BUTTON_CONTAINER_WIDTH}px);
  min-width: 0;
`;

const StyledUserProfileCard = styled(UserProfileCard)`
  max-width: fit-content;
  a {
    text-decoration: none;
  }
`;

const CircularProgressContainer = styled(CircularProgress)`
  margin-left: 5px;
`;

export {
  MarkAsReadButton,
  ActionButtonsContainer,
  RestoreButton,
  ClaimButton,
  HeaderContainer,
  StyledUserProfileCard,
  CircularProgressContainer,
  LeftSection,
};
